import Env from "../base/env";
import Channels from "../base/channels";
import gsap from "gsap";

class Launcher {
  constructor() {
    if (Env.$launcher == null) return false;
    // Dom
    this.view = Env.$launcher;
    // Flags
    this.NO_INTRO = false;
    this.LAUNCHED = false;
    // FNs
    this.setup();
  }

  exit() {
    Env.framework.TRANSITIONS.in(
      () => {
        gsap.delayedCall(0.1, () => {
          Channels.emit("launcher::exit");
        });
      },
      () => {
        this.LAUNCHED = true;
      }
    );
  }

  noLaunch() {
    setTimeout(() => {
      Env.$html.classList.add("ui--isReady");
      setTimeout(() => {
        Channels.emit("launcher::exit");
      }, 0);
      this.LAUNCHED = true;
    }, 250);
    setTimeout(() => {
      Env.$master.removeChild(this.view);
      Env.$html.classList.add("ui--isFinalize");
    }, 500);
  }

  setup() {
    Env.framework.toolbox.resetScroll();
    if (this.NO_INTRO) {
      this.noLaunch();
    } else {
      const controller = Env.framework.toolbox.getController();
      const timeoutValue =
        controller == "home" || controller == "singleModel" ? 1.5 : 0.5;
      gsap.delayedCall(timeoutValue, () => {
        this.exit();
      });
    }
  }
}

export default Launcher;
